// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module__content___3YcpD","content-text":"styles-module__content-text___1Cq8H","image":"styles-module__image___R3AzG"};